import * as yup from 'yup';

export const ContactUsValidationSchema = yup.object({
	email: yup.string().required('extensions.validation.email'),
	message: yup.string().required('extensions.validation.message'),
});

export type ContactUsType = yup.InferType<typeof ContactUsValidationSchema>;
